// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../../factories/tab-page";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import TicketStructureDialog from "./../dialogs/ticket-structure-dialog";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/sorting";
function TicketCategoryStructureRoleModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.Role = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.TicketCategoryStructureRoleCollection = ko.observableArray([]);
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteTicketCategoryStructureRole");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddTicketCategoryStructureToRole":
                self.ShowTicketCategoryStructureRoleDialog(self.Role.RoleId(), null, true);
                break;
            case "RemoveTicketCategoryStructureFromRole":
                if (self.SelectedRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteTicketCategoryStructureRole(self.SelectedRow().OpenData);
                        }
                    });
                }
                break;
            case "EditTicketCategoryStructureRole":
                if (self.SelectedRow() != null) {
                    self.ShowTicketCategoryStructureRoleDialog(self.Role.RoleId(), self.SelectedRow().TicketCategoryStructureRoleId, false);
                }
                break;
        }
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("UadmCustom/RoleTab/GetTicketCategoryStructureRoleCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedRow(null);
            self.TotalRows(0);
            self.TicketCategoryStructureRoleCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.TicketCategoryStructureRoleCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            self.ToggleToolbarButtons();
        });
    };
    self.AddTicketCategoryStructureRole = function (model, roleId) {
        tabPage.IsLoading(true);
        return Bao.post("UadmCustom/RoleTab/AddTicketCategoryStructureRole", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            model: ko.map.toJS(model),
            roleId: roleId
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.DeleteTicketCategoryStructureRole = function (ticketCategoryStructureRoleId) {
        return Bao.post("UadmCustom/RoleTab/DeleteTicketCategoryStructureRole", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            itemId: ticketCategoryStructureRoleId
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.ToolbarButtons = ko.observableArray([]);
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedRow = ko.observable({});
    self.SelectedRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "RemoveTicketCategoryStructureFromRole":
                case "EditTicketCategoryStructureRole":
                    button.Enabled(!(self.SelectedRow() == null));
                    break;
                case "AddTicketCategoryStructureToRole":
                    button.Enabled(!self.Role.IsNew());
                    break;
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("UadmCustom/RoleTab/ResetTicketCategoryStructureRole", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("UadmCustom/RoleTab/SaveTicketCategoryStructureRoleCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.init = function () {
        return self.RefreshGrid();
    };
    self.loaded = function () {
        self.ToggleToolbarButtons();
    };
    self.Copy = function (roleId, saveTime) {
        return Bao.post("UadmCustom/RoleTab/CopyTicketCategoryStructureRoleCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            newRoleId: roleId,
            saveTime: saveTime
        }));
    };
    self.ShowTicketCategoryStructureRoleDialog = function (roleId, ticketCategoryStructureId, isNew) {
        var dialog = new TicketStructureDialog(tabPage, self, "TicketCategory");
        dialog.ShowTicketStructureRoleDialog(roleId, ticketCategoryStructureId, isNew);
    };
}
;
export default TicketCategoryStructureRoleModel;